<template lang="pug">
.form-container
  // ───────── DATOS DEL USUARIO ─────────
  .section
    .section-header
      .section-icon 🧾
      .section-title Datos del Usuario
    .section-body
      .ed-grid.s-grid-1.m-grid-4.rows-gap.gap-1
        .s-cols-1.m-x-1
          label.required Tipo de Vinculación:
        .s-cols-1.m-cols-1
          dx-select-box.input-modern(
            v-model="modelo.tipoVinculacion"
            :data-source="listas.tiposVinculacion"
            display-expr="nombre"
            value-expr="valor"
            placeholder="Seleccione tipo"
            @value-changed="onCambioVinculacion"
          )

        .s-cols-1.m-x-1
          label.required Usuario Red:
        .s-cols-1.m-cols-1
          dx-text-box.input-modern(v-model="modelo.usuarioRed" placeholder="Ej: jlopez")

        .s-cols-1.m-x-1
          label.required Documento:
        .s-cols-1.m-cols-1
          dx-text-box.input-modern(v-model="modelo.documento")

        .s-cols-1.m-x-1
          label.required Correo:
        .s-cols-1.m-cols-2
          dx-text-box.input-modern(v-model="modelo.correo" mode="email" placeholder="usuario@empresa.com")

        .s-cols-1.m-x-1
          label Requiere Reembolsos:
        .s-cols-1.m-cols-2
          dx-check-box(
            :value="modelo.requiereReembolsos"
            text="Sí"
            @value-changed="onCheckReembolsosChange"
          )

  // --- Campos dinámicos de reembolso ---
  transition(name="fade")
    template(v-if="modelo.requiereReembolsos")
      .section.subtle.mt-2
        .section-header
          .section-icon 💳
          .section-title Información de Reembolsos
        .section-body
          .ed-grid.s-grid-1.m-grid-4.rows-gap.gap-1
            .s-cols-1.m-x-1
              label.required Código SAP:
            .s-cols-1.m-cols-1
              dx-text-box.input-modern(v-model="modelo.codigoSap" placeholder="Ej: 123456")

            .s-cols-1.m-x-1
              label.required Centros de Costos:
            .s-cols-1.m-cols-3
              dx-tag-box.input-modern(
                v-model="modelo.centrosCostos"
                :data-source="listas.centrosCostos"
                display-expr="nombre"
                value-expr="id"
                placeholder="Seleccione uno o varios centros"
                :show-selection-controls="true"
                :search-enabled="true"
              )

  // ───────── INFORMACIÓN GENERAL ─────────
  transition(name="fade")
    template(v-if="modelo.tipoVinculacion != 'empleado'")
      .section
        .section-header
          .section-icon 👤
          .section-title Información General
        .section-body
          .ed-grid.s-grid-1.m-grid-4.rows-gap.gap-1
            .s-cols-1.m-x-1
              label.required Código Usuario:
            .s-cols-1.m-cols-1
              dx-text-box.input-modern(v-model="modelo.codigoUsuario" placeholder="Ej: G001")

            .s-cols-1.m-x-1
              label.required Nombre Completo:
            .s-cols-1.m-cols-2
              dx-text-box.input-modern(v-model="modelo.nombreCompleto" placeholder="Ej: Juan Pérez")

            .s-cols-1.m-x-1
              label Cargo:
            .s-cols-1.m-cols-3
              dx-select-box.input-modern(
                v-model="modelo.cargoId"
                :data-source="listas.cargos"
                display-expr="nombre"
                value-expr="id"
                placeholder="Seleccione cargo"
                :searchEnabled = "true"
              )
</template>

<script>
export default {
  name: "DatosGeneralesTab",
  props: {
    modelo: { type: Object, required: true },
    listas: { type: Object, required: true }
  },
  methods: {
    onCambioVinculacion(e) {
      this.modelo.tipoVinculacion = e.value;
     
    },
    onCheckReembolsosChange(e) {
      this.modelo.requiereReembolsos = e.value;
      if (!e.value) {
        this.modelo.codigoSap = "";
        this.modelo.centrosCostos = [];
      }
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
:deep(.dx-popup-content),
:deep(.dx-tabpanel),
:deep(.dx-multiview-wrapper),
:deep(.dx-multiview-item-content),
:deep(.dx-tab-content),
:deep(.dx-tabpanel-container),
:deep(.dx-tabpanel .dx-multiview-item-content),
:deep(.dx-overlay-content),
:deep(.dx-popup-wrapper),
:deep(.content-container) {
  padding-left: 0 !important;
  margin-left: 0 !important;
}

/* 🔹 FORM CONTAINER CENTRADO */
.form-container {
  background: #f8fafc;
  padding: 10px 12px;
  border-radius: 10px;
  max-width: 700px;
  margin: 0 auto;          /* Centra horizontalmente */
  display: flex;
  flex-direction: column;
  align-items: center;     /* Centra su contenido */
  justify-content: flex-start;
  min-height: 100%;        /* Asegura que ocupe todo el alto del popup */
}

.section {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  margin-bottom: 15px;
  padding: 10px 15px;
  width: 100%;             /* 🔹 Asegura que el contenido se adapte al ancho */
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.section:hover {
  transform: translateY(-2px);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
}
.section.subtle {
  background: #f4faff;
  border-left: 3px solid #4ea1ff;
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}
.section-icon {
  font-size: 17px;
  margin-right: 5px;
}
.section-title {
  font-weight: 700;
  font-size: 14px;
  color: #005b99;
}

.input-modern {
  width: 88%;
  background-color: #ffffff !important;
  border-radius: 6px;
  min-height: 28px;
  box-shadow: inset 0 0 0 1px #dcdcdc;
  transition: all 0.2s ease;
}
.input-modern:hover {
  box-shadow: inset 0 0 0 1.5px #4ea1ff;
}
.input-modern:focus-within {
  box-shadow: inset 0 0 0 2px #0078d4;
}

label {
  font-weight: 600;
  color: #333;
  margin-bottom: 2px;
  font-size: 13.3px;
}
.required::after {
  content: " *";
  color: #d9534f;
}

.rows-gap { row-gap: 8px !important; }
.mt-2 { margin-top: 8px; }

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}
</style>
